import { Typography } from '@faceup/ui-base'
import { useElementSize } from '@mantine/hooks'
import { twMerge } from 'tailwind-merge'
import type { FormVariant } from './config'

const Form: FormVariant['form'] = ({ children }) => {
  return <div className='flex flex-col gap-4'>{children}</div>
}

const FormItem: FormVariant['item'] = ({
  children,
  label,
  hint,
  secondary,
  withAsterisk,
  errorMessage,
  formItemProps,
  notClickableLabel,
}) => {
  const { ref: secondarySizeRef, width: secondaryWidth } = useElementSize()

  const isSomethingInLabelRow = label || hint || secondary

  if (!isSomethingInLabelRow) {
    return (
      <div {...formItemProps} className={twMerge('relative w-full', formItemProps?.className)}>
        {children}
        {errorMessage && <Typography.Text type='danger'>{errorMessage}</Typography.Text>}
      </div>
    )
  }

  return (
    <div {...formItemProps} className={twMerge('relative w-full', formItemProps?.className)}>
      {secondary && (
        <div className='absolute end-0' ref={secondarySizeRef}>
          {secondary}
        </div>
      )}
      {/* biome-ignore lint/a11y/noLabelWithoutControl: Wrapper label for form item grouping */}
      <label>
        {notClickableLabel && <input className='invisible absolute h-0 w-0' />}
        <div className='flex flex-col gap-4'>
          <div className='flex flex-col gap-1'>
            <div style={{ width: `calc(100% - ${secondaryWidth}px)` }}>
              <Typography.Title level={4}>
                <span className={twMerge(errorMessage ? 'text-colorError' : '', 'sensitive')}>
                  {label}
                </span>{' '}
                {withAsterisk && <span className='text-colorError'>*</span>}{' '}
              </Typography.Title>
            </div>
            {hint && (
              <Typography.Text className='sensitive text-colorTextDescription'>
                {hint}
              </Typography.Text>
            )}
          </div>
          {children}
        </div>
      </label>
      {errorMessage && <Typography.Text type='danger'>{errorMessage}</Typography.Text>}
    </div>
  )
}

export const blackVariant: FormVariant = {
  form: Form,
  item: FormItem,
}
